import './index.css'
import 'dayjs/locale/th'
import 'mobx-react-lite/batchingForReactDom'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import LoadingPage from './controls/LoadingPage'
import { BrowserRouter } from 'react-router-dom'
import { ConfigProvider, Spin } from 'antd'
import thTH from 'antd/lib/locale-provider/th_TH'
import buddhistEra from 'dayjs/plugin/buddhistEra'
import dayjs from 'dayjs'
import CustomizeRenderEmpty from './controls/CustomizeRenderEmpty'

import Icon from '@ant-design/icons'

import { ReactComponent as LoadingSvg } from './assets/svg/loading_ellipsis.svg'

const antIconLoading = (
    <Icon
        component={LoadingSvg}
        style={{
            margin: '0px',
            position: 'absolute',
            transform: 'translate(-50%, -25%)',
            top: '50%',
            left: '50%',
            fontSize: '6rem',
        }}
    />
)

Spin.setDefaultIndicator(<Spin indicator={antIconLoading} />)

dayjs.extend(buddhistEra)

const closeConsole = () => {
    window.console.clear()
    console.log(
        '%cWeb-Self | CBT Thailand',
        'font-weight: bold; font-size: 50px; color: #068f3f; text-shadow: 1px 1px 0px black, 1px -1px 0px black, -1px 1px 0px black, -1px -1px 0px black',
    )
    window.console.log = function () {
        // console.error('This is console for developer')
        window.console.log = function () {
            return false
        }
    }

    window.console.warn = function () {
        window.console.warn = function () {
            return false
        }
    }

    window.console.error = function () {
        window.console.error = function () {
            return false
        }
    }
    window.console.info = function () {
        window.console.info = function () {
            return false
        }
    }
}

process.env.NODE_ENV !== 'development' && closeConsole()

ReactDOM.render(
    <BrowserRouter basename={process.env.PUBLIC_URL}>
        <ConfigProvider locale={thTH} renderEmpty={CustomizeRenderEmpty}>
            <LoadingPage />
            <App />
        </ConfigProvider>
    </BrowserRouter>,
    document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
